import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { debounceTime, skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-addmisutilization-case',
  templateUrl: './addmisutilization-case.component.html',
  styleUrls: ['./addmisutilization-case.component.scss']
})
export class AddmisutilizationCaseComponent {
  pdsForm!: FormGroup;
  UserDetails: any;
  blockList: any[] = [];
  societyList: any[] = [];
  targetForm!: FormGroup;
  financialYears: any[] = [];
  reportingYears: any[] = [];
  filteredMonths: any[] = [];
  circlesList:any[]=[];
  rows: any[] = [];
  months: any[] = [];
  showButton=false;
  currentlyMonth: any = {};
  monthKeyMap: Record<number, string> = {
 1: 'april',
  2: 'may',
  3: 'june',
  4: 'july',
  5: 'august',
  6: 'september',
  7: 'october',
  8: 'november',
  9: 'december',
  10: 'january',
  11: 'february',
  12: 'march'
  };


  currentYear = new Date().getFullYear();
  currentMonth = new Date().getMonth(); // 0-based index
  constructor(private reportService: ReportsService, private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {

  }

  ngOnInit(): void {

    this.pdsForm = this.fb.group({
      // financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],
      defaulterSociety: ['', Validators.required],
      sinceYear: ['', Validators.required],
      offilneEntryYear: ['', Validators.required],

      duringMonth: ['', Validators.required],
      misUtilizeAmount: ['', Validators.required],
      recoverAmount: ['', Validators.required],

    });
    this.targetForm = this.fb.group({

      blockOffice: ['', Validators.required],

    });


    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;


    switch (this.UserDetails?.roleId) {


      case 11:
        //  this.targetForm.addControl('blockOffice', new FormControl([Validators.required]))
        this.pdsForm.controls['blockOffice'].disable();

        break;
      default:
    }
    // this.targetForm.get('blockOffice')?.valueChanges
    //   .pipe(debounceTime(300)).subscribe((val: any) => {

    //     if (this.targetForm.valid) {
    //       this.GetMisutilizationData(val)
    //     }
    //   });
 

    this.getTargetCount();
    this.GetYearAndMonth("i");
    
          switch (this.UserDetails?.roleId) {
      case 13:
       
        break;
      case 1:
             this.targetForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
       this.getCircle();
        break;
      case 11:
        this.targetForm.controls['blockOffice'].disable();
       
    
        break;
      default:
    }
       this.targetForm.valueChanges
            .pipe(debounceTime(300))  // waits 300ms after last change
            .subscribe(values => {
              if (this.targetForm.valid) {
                this.GetMisutilizationData();
              }
            });
  }


  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        // this.circlesList = res.data.circles;
        if(this.UserDetails?.roleId !== 1){
       this.blockList = res.data.blocks;
        }
 
          this.financialYears = res.data.financialYears
           if(this.UserDetails?.roleId ==11){
          this.targetForm.controls['blockOffice'].setValue(this.UserDetails?.iBlockId);
            this.targetForm.controls['blockOffice'].disable();
             this.GetMisutilizationData();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  getCircle() {
  
    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;
        
 
    
      }
    },
      (error: any) => {
      }
    );
  }

   GetBlock() {


    let obj = {
      // "action": "GetBIDropdownValue",
      "blockId":0,
      "circleId": this.targetForm.value?.circleOffice
      // "circleId": 0
    }
 
    
    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {
            
        this.blockList = res.data?.block;
          this.targetForm.controls['blockOffice'].setValue('');
    
      }
    },
      (error: any) => {
      }
    );
  }
  getSocieties(blockId: any) {

    this.reportService.getSocieties(blockId).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.societyList = res.data;

      }
    },
      (error: any) => {
      }
    );
  }
  GetYearAndMonth(blockId?: any) {

    this.reportService.GetYearAndMonth({}).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;


        // this.financialYears = res.data.financialYears
        this.months = res.data.months


      }
    },
      (error: any) => {
      }
    );
  }
  //GetMisutilizationData
  GetMisutilizationData(blockId?: any) {

    let obj = {
      "blockId":blockId?blockId:Number( this.targetForm.getRawValue().blockOffice)
    }

    this.reportService.GetMisutilizationData(obj).subscribe((res: any) => {
     if (res && res?.data && res?.data.length > 0) {
           
            let lastRow = res?.data[res?.data.length - 1];
           
            this.rows =res?.data;
            this.showButton =true
            // if (Number(lastRow?.dataMonth) != 12 && Number(lastRow?.dataMonth) < 12) {
            //             let fyear = this.targetForm.getRawValue()?.financialYear.financialYear
            //      let year = (Number(lastRow?.dataMonth) <= 9)? fyear?.split('-')[0] :fyear.split('-')[1] 
            //           this.currentlyMonth.key = (Number(lastRow?.dataMonth) + 1).toString();
            //   this.currentlyMonth.name = this.monthKeyMap[(Number(lastRow?.dataMonth) + 1)] + ', ' + year;
            //            this.showButton = true
            // } else {
            //   this.showButton = false
            // }


          } else {
         this.rows = []
            this.showButton = true;
            this.currentlyMonth.name = this.monthKeyMap['1'] + ', ' + this.targetForm.value?.financialYear?.startYear
            this.currentlyMonth.key = '1';
              this.toastService.showInfo('NO Data Found!')
          }

      this.showButton =  true;
    },
      (error: any) => {
      }
    );
  }
  getCurrentFinancialYearStart(): number {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;

    // Financial year starts from April, so:
    return month >= 4 ? year : year - 1;
  }


  onSinceYearChange(event: any,prefill?:any) {

    const selectedStartYear = parseInt(event.target.value, 10);
    const currentFYStart = this.getCurrentFinancialYearStart();

    if (!isNaN(selectedStartYear)) {
      // Filter financial years from selected startYear to current financial year
      this.reportingYears = this.financialYears.filter(
        fy => fy.startYear >= selectedStartYear && fy.startYear <= currentFYStart
      );
      
if(!prefill){
   // Reset dependent fields
      this.pdsForm.get('offilneEntryYear')?.setValue('');
      this.filteredMonths = [];
      this.pdsForm.get('duringMonth')?.setValue('');
}
   
    }
  }


  onReportingYearChange(event: any,prefill?:any) {
    const selectedYear = parseInt(event.target.value, 10);

    if (!isNaN(selectedYear)) {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1; // 1-12

      if (selectedYear < currentYear) {
        // Full financial year
        this.filteredMonths = [...this.months];
      } else if (selectedYear === currentYear) {
        // Show only months up to current month in financial year format
        this.filteredMonths = this.months.filter(month => {
          // Since financial year starts from April, we consider April (4) as month 1
          const monthOrder = this.getFinancialMonthOrder(month.iMonthId);
          const currentOrder = this.getFinancialMonthOrder(currentMonth);
          return monthOrder <= currentOrder;
        });
      }
if(!prefill){
      this.pdsForm.get('duringMonth')?.setValue('');

}
    }
  }
  getFinancialMonthOrder(monthId: number): number {
    // Financial year starts from April (4) to March (3)
    if (monthId >= 4 && monthId <= 12) {
      return monthId - 3; // April = 1, May = 2, ..., Dec = 9
    } else {
      return monthId + 9; // Jan = 10, Feb = 11, Mar = 12
    }
  }

  viewModel(event: any) {
    this.pdsForm.controls['blockOffice'].setValue(this.targetForm.value?.blockOffice)
    this.getSocieties(this.UserDetails?.iBlockId)
    this.openModal('readMoreModal');
  }

  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }



  onSubmit() {
    if (this.pdsForm.valid) {
      // 🔑 getRawValue() ensures disabled fields are included
      const payload = this.pdsForm.getRawValue();
      let entryYear = this.reportingYears.find((i) => i?.startYear == payload?.offilneEntryYear)
      let obj = {
        "blockId": payload?.blockOffice,
        "defaulterSociety": payload?.defaulterSociety,
        "misutilizationSinceYear": payload?.sinceYear,
        "offlineEntriesYear": payload?.offilneEntryYear?.toString(),
        "offlineEntriesMonth": payload?.duringMonth,
        "openingBalance": payload?.misUtilizeAmount,
        "amountRecovered": payload?.recoverAmount,
        "createdBy":  this.edit ?0:this.UserDetails?.id,
        "modifiedBy": this.edit ?this.UserDetails?.id:0,
        id:this.edit ? this.editId:0
      }

      this.reportService.addMisutilizationData(obj).subscribe((res: any) => {
        if (res) {
          if (res?.status == 200) {
            this.toastService.showSuccess(res.message);

            this.hideModal('readMoreModal');
            this.pdsForm.reset();
            this.pdsForm.markAsUntouched();
            this.GetMisutilizationData(this.targetForm.value?.blockOffice);
          }

        }
        this.edit =false
      },
        (error: any) => {
        }
      );


    } else {
      this.pdsForm.markAllAsTouched();
    }
  }

  edit= false;
  editId=0
  editRow(row: any) {

    const data = row;
    const headerData = this.targetForm.getRawValue();
    this.pdsForm.controls['blockOffice'].setValue(this.targetForm.value?.blockOffice)
    this.getSocieties(this.UserDetails?.iBlockId)
    let eventSince:any={
      "target":{
        value:data.misutilizationSinceYear
      }
    }

this.onSinceYearChange(eventSince,true)
 let eventEntry:any={
      "target":{
        value:data.offlineEntriesYear
      }
    }
    this.onReportingYearChange(eventEntry,true)
 
    setTimeout(() => {
       this.pdsForm.patchValue({
      defaulterSociety: data.societyId,
      // sinceYear: data.misutilizationSinceYear,
      // offilneEntryYear: Number(),
      duringMonth: data.offlineEntriesMonth,
      misUtilizeAmount: data.openingBalance,
      recoverAmount: data.amountRecovered
    });
       this.pdsForm.controls['sinceYear'].setValue(data.misutilizationSinceYear)
    
    this.pdsForm.controls['offilneEntryYear'].setValue(Number(data.offlineEntriesYear))

    }, 300);
   
this.editId = data?.id
this.edit =true

    this.openModal('readMoreModal');
  }

    DeleteMisutilization(id: any) {
    this.reportService.DeleteMisutilization(id).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
   this.deleteIndex = 0;
          // this.hideModal();
          this.GetMisutilizationData();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  VerifyMisutilization(id: any) {
    this.reportService.VerifyMisutilization(id).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
   this.deleteIndex = 0;
          // this.hideModal();
          this.GetMisutilizationData();
        }

      }
    },
      (error: any) => {
      }
    );
    
  }
         deleteIndex:any
 setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  cancelDelete(){
   this.deleteIndex = 0;

  }

  closeModel(){
  this.pdsForm.reset()
  this.pdsForm.markAsUntouched()
  this.editId = 0
this.edit =false
}
}
